<template>
  <div class="fixed bottom-4 right-4 z-50 flex flex-col gap-2 pointer-events-none">
    <TransitionGroup name="toast">
      <div 
        v-for="notification in visibleNotifications" 
        :key="notification.id"
        :class="[
          'pointer-events-auto px-6 py-3 rounded-lg shadow-2xl flex items-center gap-3 backdrop-blur-md border border-white/10 min-w-[300px] max-w-md transition-all duration-300 transform',
          typeClasses[notification.type] || typeClasses.info
        ]"
      >
        <!-- Icon based on type -->
        <div class="flex-shrink-0">
          <svg v-if="notification.type === 'success'" class="w-6 h-6 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <svg v-else-if="notification.type === 'error'" class="w-6 h-6 text-rose-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <svg v-else class="w-6 h-6 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>

        <!-- Message -->
        <span class="text-white font-medium text-sm flex-grow">{{ notification.message }}</span>

        <!-- Close button -->
        <button 
          @click="store.removeNotification(notification.id)"
          class="text-white/40 hover:text-white transition-colors"
        >
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l18 18" />
          </svg>
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useNotificationStore } from '../stores/notification'

const store = useNotificationStore()

const visibleNotifications = computed(() => store.notifications.filter(n => n.visible))

const typeClasses = {
  success: 'bg-emerald-900/80 text-emerald-100 border-emerald-500/30',
  error: 'bg-rose-900/80 text-rose-100 border-rose-500/30',
  info: 'bg-slate-900/80 text-blue-100 border-blue-500/30'
}
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(30px) scale(0.9);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(30px) scale(0.9);
}

.toast-move {
  transition: transform 0.4s ease;
}
</style>
